import React, { Component } from "react";
import Input from "../../Input";
import "./style.scss";
import { autoCapital, formDataGenerator } from "../../../../../utils/common";
import { bindActionCreators } from "redux";
import {
  clearVerifyResponse,
  checkExistingUser,
  verifyOTP,
  clearSendOTP,
  postInvestDataETF,
} from "../action";
import { smallCaseTokenHide } from "../../../landing/ProductSolutions/actions";
import { connect } from "react-redux";

class BasicForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      common: "",
      otp: "",
      error: {},
      seconds: 0,
      enableResendBtn: false,
      enableSend: true,
      showOtp: false,
      fieldDisabled: false,
      enableInvest: false,
      redirectSeconds: 5,
      showOtpScreen: true,
      verificationText: "Verifying User",
    };
    this.errors = {};
  }

  // componentDidMount = () => {
  //     const {location : { pathname, search }} = this.props;

  //     if(search) {
  //         if(search.includes('uuid')){
  //             this.setState({prev_txn_uuid: search.split('uuid=')[1], showOtpScreen: false,verified : 1}, () => this.sendOTP());
  //         }
  //     }
  // }

  onReset = (event) => {
    event && event.preventDefault();
    const { clearVerifyResponse, clearSendOTP } = this.props;
    this.setState({
      name: "",
      common: "",
      email: "",
      mobile: "",
      otp: "",
      error: {},
      showOtp: false,
      enableResendBtn: false,
      enableSend: true,
      seconds: 0,
    });
    this.transactionId = "";
    this.errors = {};
    clearVerifyResponse();
    clearSendOTP();
    clearInterval(this.timer);
    clearTimeout(this.submitTimeout);
  };

  onChange = (name, value) => {
    let { mobile, email, common } = this.state,
      { verifyOTP } = this.props;

    this.setState({
      [name]: value,
    });
    this.validateChange(name, value);
    if (name === "otp" && value.length === 6) {
      let formdata = {
        mobileNumber: mobile ? mobile : "",
        email,
        otpCode: value,
        type: "talisma_verification",
      };
      verifyOTP(formDataGenerator(formdata));
    }
  };
  validateChange = (name, value) => {
    if (value.length !== 0) {
      switch (name) {
        case "common":
          if (/^[6-9]{1}[0-9]{9}$/.test(value)) {
            this.setState({
              mobile: value,
              email: "",
            });
            delete this.errors[name];
          } else if (/[A-Za-z0-9._%+-]+@[A-Za-z]+\.[a-zA-Z]{2,4}/.test(value)) {
            this.setState({
              email: value,
              mobile: "",
            });
            delete this.errors[name];
          } else {
            this.errors.common = "Please enter correct Email or Mobile Number";
          }
          this.setState({
            error: this.errors,
          });
          break;

        case "name":
          /^[a-zA-Z\s]*$/.test(value)
            ? delete this.errors[name]
            : (this.errors.name = "Only alphabets allowed");
          this.setState({
            error: this.errors,
          });
          break;
        default:
          this.errors[name] ? delete this.errors[name] : false;
      }
    } else {
      delete this.errors[name];
      this.setState({
        error: this.errors,
      });
    }
  };

  onSubmit = async (event) => {
    event && event.preventDefault();
    const { name, mobile, email, otp, prev_txn_uuid, verified } = this.state,
      {
        postInvestDataETF,
        closeAction,
        postSmallCase,
        item,
        verifyOTP,
        postSmallCaseID,
        data,
        smallCaseTokenHide,
      } = this.props;

    let tokenId = await smallCaseTokenHide();
    let tokenDataId = {
      authToken: "",
      secretKey: "",
    };

    if (tokenId && tokenId.data) {
      window.scGate = new scDK({
        gateway: "hdfcgateway",
        smallcaseAuthToken: tokenId.data.authToken,
        config: {
          amo: true,
        },
      });
      tokenDataId.authToken = tokenId.data.authToken;
      tokenDataId.secretKey = tokenId.data.secretKey;
    }

    let formdata = {};

    let res =
      tokenId.data && (await postSmallCase(item.ticker.trim(), tokenDataId));
    this.transactionId = res.data.transactionId;
    formdata = {
      fullname: name,
      email: email ? email : "",
      mobilenumber: mobile ? mobile : "",
      transactionId: this.transactionId,
      prev_txn_uuid: prev_txn_uuid ? prev_txn_uuid : "",
      verified: verified ? verified : "",
    };

    this.submitTimeout = setTimeout(async () => {
      let response = await postInvestDataETF(formDataGenerator(formdata));
      closeAction();
      // eslint-disable-next-line no-undef
      await scGate
        .triggerTransaction({ transactionId: res.data.transactionId })
        .then((res) => res)
        .catch((err) => err);
      postSmallCaseID(
        formDataGenerator({
          fullname: name,
          email: email ? email : "",
          mobilenumber: mobile ? mobile : "",
          uuid: this.state.userId && this.state.userId,
          transactionId: res.data.transactionId,
          fund_name: item.title,
          prev_txn_uuid: prev_txn_uuid ? prev_txn_uuid : "",
          verified: verified ? verified : "",
        })
      );
    }, 2000);
  };

  sendOTP = async (event) => {
    event && event.preventDefault();
    const { mobile, email, name, prev_txn_uuid, verified, showOtpScreen } =
        this.state,
      { checkExistingUser, clearVerifyResponse, data } = this.props;
    let formdata = {
      fullname: name,
      mobile: mobile ? mobile : "",
      email: email ? email : "",
      prev_txn_uuid: prev_txn_uuid ? prev_txn_uuid : "",
      verified: verified ? verified : "",
    };
    if (showOtpScreen) {
      this.setState(
        {
          otp: "",
        },
        () => clearVerifyResponse()
      );
      this.timer = setInterval(() => {
        if (this.state.seconds > 0) {
          this.setState((prevState) => ({
            enableSend: false,
            seconds: prevState.seconds - 1,
            fieldDisabled: true,
          }));
        } else {
          clearInterval(this.timer);
          // clearVerifyResponse();
          this.setState({
            enableResendBtn: true,
            enableSend: true,
            fieldDisabled: false,
          });
        }
      }, 1050);
      let response = await checkExistingUser(formDataGenerator(formdata));
      this.setState({
        seconds: 30,
        showOtp: true,
      });
      if (this.state.uuid) {
        this.setState({ enableInvest: true, showOtp: false });
        this.redirectIn = setInterval(() => {
          if (this.state.redirectSeconds > 1) {
            this.setState((prevState) => ({
              redirectSeconds: prevState.redirectSeconds - 1,
            }));
          } else {
            clearInterval(this.timer);
          }
        }, 1000);
        this.submitTimeout = setTimeout(() => this.onSubmit(), 4000);
      }
    } else {
      await checkExistingUser(formDataGenerator(formdata));
      if (this.state.uuid) {
        this.setState({
          verificationText: "User verified, redirecting to Smallcase Gateway",
        });
        this.onSubmit();
      } else {
        this.setState({ verificationText: "User not verified" });
      }
    }
    // }
  };
  componentDidUpdate(prevPros) {
    if (
      prevPros &&
      prevPros.data &&
      prevPros.data.modal &&
      prevPros.data.modal
    ) {
      if (
        prevPros.data.modal.sendOtp &&
        prevPros.data.modal.sendOtp.uuid !== this.props.data.modal.sendOtp.uuid
      ) {
        this.setState({
          uuid: this.props.data.modal.sendOtp.uuid,
        });
      } else if (
        !prevPros.data.modal.sendOtp &&
        this.props.data &&
        this.props.data.modal &&
        this.props.data.modal.sendOtp &&
        this.props.data.modal.sendOtp.uuid
      ) {
        this.setState({
          uuid: this.props.data.modal.sendOtp.uuid,
        });
      }
    }
    if (
      prevPros &&
      prevPros.data &&
      prevPros.data.modal &&
      prevPros.data.modal
    ) {
      if (
        prevPros.data.modal.registerData &&
        prevPros.data.modal.registerData.userId !==
          this.props.data.modal.registerData.userId
      ) {
        this.setState({
          userId: this.props.data.modal.registerData.userId,
        });
      } else if (
        !prevPros.data.modal.registerData &&
        this.props.data &&
        this.props.data.modal &&
        this.props.data.modal.registerData &&
        this.props.data.modal.registerData.userId
      ) {
        this.setState({
          userId: this.props.data.modal.registerData.userId,
        });
      }
    }
  }

  componentWillUnmount() {
    this.onReset();
  }

  render() {
    const { closeAction, okAction, verifyStatus } = this.props,
      {
        name,
        common,
        otp,
        error,
        enableSend,
        enableResendBtn,
        showOtp,
        seconds,
        fieldDisabled,
        showOtpScreen,
        verificationText,
      } = this.state;
    return (
      <div className="alert-modal">
        <div className="popupOuter">
          <div className="popupSec">
            <i
              onClick={closeAction}
              id="close-focued"
              role="tab"
              tabIndex="0"
              className="icon-close cross"
            />
            <h4 className="etf-modal-title">
              Initiate investment by filling in details
            </h4>
            {showOtpScreen && (
              <form>
                <Input
                  name="name"
                  autoFocus
                  placeHolder="Enter Name"
                  value={autoCapital(name)}
                  isAlpha
                  onChange={this.onChange}
                  // blurChange={this.validateChange}
                  errorMessage={error.name}
                  disableField={fieldDisabled}
                  label
                  required
                />
                <div className="d-flex send-otp">
                  <Input
                    name="common"
                    placeHolder="Enter Mobile OR Email "
                    value={common}
                    // isAlphaNumeric
                    onChange={this.onChange}
                    // blurChange={this.validateChange}
                    errorMessage={error.common}
                    disableField={fieldDisabled}
                    label
                    required
                  />
                  {!this.state.uuid && (
                    <button
                      className="btn-primary otp-cta"
                      disabled={
                        !(
                          common.length &&
                          common.length > 7 &&
                          Object.keys(error).length === 0 &&
                          name &&
                          enableSend
                        )
                      }
                      onClick={this.sendOTP}
                    >
                      {seconds !== 0
                        ? `Wait ${seconds} seconds`
                        : !enableResendBtn
                        ? "Send OTP"
                        : "Resend OTP"}
                    </button>
                  )}
                </div>
                {!this.state.uuid && (
                  <div
                    className={
                      verifyStatus && verifyStatus.statusCode === 1
                        ? "d-flex otp-box success"
                        : "d-flex otp-box"
                    }
                  >
                    <Input
                      name="otp"
                      placeHolder="Enter OTP"
                      value={otp}
                      isNumeric
                      blurChange={this.validateChange}
                      onChange={this.onChange}
                      maxLength={6}
                      errorMessage={
                        otp.length
                          ? verifyStatus && verifyStatus.statusMsg
                          : null
                      }
                      disableField={
                        !showOtp ||
                        (verifyStatus && verifyStatus.statusCode === 1)
                      }
                    />
                  </div>
                )}
                {!this.state.uuid && (
                  <button
                    className="btn-primary continue"
                    disabled={
                      !(
                        Object.keys(error).length === 0 &&
                        common &&
                        name &&
                        verifyStatus &&
                        verifyStatus.statusCode === 1
                      )
                    }
                    onClick={this.onSubmit}
                  >
                    Continue to Invest
                  </button>
                )}
                {this.state.uuid && (
                  <div>
                    User already exists, redirecting to Smallcase gateway in{" "}
                    {this.state.redirectSeconds} seconds
                  </div>
                )}
              </form>
            )}
            {!showOtpScreen && <div>{verificationText}</div>}
            {}
          </div>
        </div>
        <div className="popup_overlay black_overlay" />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state,
  verifyStatus: state.modal.verifyOtpStatus,
  smallCaseTokenAuthId: state.ProductSolution.home.productAllFund,
});

const mapDispatchToProps = (dispatch) => ({
  checkExistingUser: bindActionCreators(checkExistingUser, dispatch),
  clearSendOTP: bindActionCreators(clearSendOTP, dispatch),
  verifyOTP: bindActionCreators(verifyOTP, dispatch),
  clearVerifyResponse: bindActionCreators(clearVerifyResponse, dispatch),
  postInvestDataETF: bindActionCreators(postInvestDataETF, dispatch),
  smallCaseTokenHide: bindActionCreators(smallCaseTokenHide, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(BasicForm);
